import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { HeaderModule } from './header/header.module';
import { FooterComponent } from './footer/footer.component';
import { NavigationModule } from './navigation/navigation.module';
import { ShortcutComponent } from './shortcut/shortcut.component';
import { ToggleActiveDirective } from '../utils/toggle-active.directive';
import { MainLayoutComponent } from './app-layouts/main-layout.component';
import { EmptyLayoutComponent } from './app-layouts/empty-layout.component';
import { RouterModule} from '@angular/router';
import { UtilsModule} from '../utils/utils.module';
import { LoginModule } from '../../pf.main/login/login.module';
import { PasswordModule } from '../../pf.main/password/password.module';
import { AuthoritySelectModule } from '../../pf.main/authorityselect/authorityselect.module';

@NgModule({
  imports: [
    CommonModule,
    HeaderModule,
    NavigationModule,
    FormsModule,
    RouterModule,
    UtilsModule,
    LoginModule,
    PasswordModule,
    AuthoritySelectModule
  ],
  declarations: [
    FooterComponent,
    ShortcutComponent,
    MainLayoutComponent,
    EmptyLayoutComponent,
  ],
  exports: [
    HeaderModule,
    NavigationModule,
    FooterComponent,
    ShortcutComponent,
  ]
})
export class SmartadminLayoutModule {

}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/layout.module.ts